// @flow
import * as React from 'react';
import { connect } from 'react-redux';
import { bindActionCreators } from 'redux';
import deepEqual from 'react-fast-compare';
import { isLocationEmpty } from 'utils/search/sidefilters';
import {
  sideFacetsForType,
  searchableFacetsForType,
  initialFacetFiltersForMainSearch
} from 'utils/search/searchFacets';
import SearchFiltersSidebar from 'components/SearchFiltersSidebar';
import { getDefaultSearchRadius } from 'utils/constants';
import type { Dispatch } from '../redux/main';
import type { SortType } from '../redux/main/reducers/mainSearch';
import {
  updateSearchLocation,
  clearSearchLocation
} from '../redux/main/actions/currentUser';
import {
  setSearchFilter,
  selectSearchFilterOption,
  deselectSearchFilterOption,
  selectSearchFilterSpecificOptions,
  selectAllSearchFilterOptions,
  setSearchSort,
  setSearchRadius,
  clearAllFilters
} from '../redux/main/actions/mainSearch';

const mapStateToProps = ({
  mainSearch: { query, sort, filters, searchFacets, facetsThatArentLoaded },
  currentUser: { searchLocation },
  searchRadius
}) => {
  const sortValue = sort[filters.type];
  return {
    query,
    sort: sortValue,
    filters,
    searchFacets,
    facetsThatArentLoaded,
    defaultFiltersSet:
      searchRadius.value === getDefaultSearchRadius(sortValue) &&
      deepEqual(
        filters,
        initialFacetFiltersForMainSearch(searchFacets, facetsThatArentLoaded, {
          type: filters.type || 'JOB'
        })
      ) &&
      isLocationEmpty(searchLocation),
    searchLocation,
    searchRadius: searchRadius.value
  };
};

const mapDispatchToProps = (dispatch: Dispatch) => ({
  ...bindActionCreators(
    {
      setSearchFilter,
      selectSearchFilterOption,
      deselectSearchFilterOption,
      selectSearchFilterSpecificOptions,
      selectAllSearchFilterOptions,
      setSearchRadius,
      setSearchSort,
      clearAllFilters
    },
    dispatch
  ),
  setSearchLocation: (searchLocation: ?SearchLocation) => {
    if (searchLocation) {
      dispatch(updateSearchLocation(searchLocation, true));
    } else {
      dispatch(clearSearchLocation(true));
    }
  },
  setSearchRadius: (searchRadius: string) => {
    dispatch(setSearchRadius(searchRadius, true));
  }
});

type Props = {
  query: string,
  defaultFiltersSet: boolean,
  facetsThatArentLoaded: Array<string>,
  searchLocation: ?SearchLocation,
  searchRadius: string,
  sort: SortType,
  filters: SearchFilters,
  searchFacets: Object,
  setSearchFilter: Function,
  selectSearchFilterOption: Function,
  deselectSearchFilterOption: Function,
  selectSearchFilterSpecificOptions: Function,
  selectAllSearchFilterOptions: Function,
  setSearchLocation: Function,
  setSearchRadius: Function,
  setSearchSort: Function,
  clearAllFilters: Function
};

const SearchFiltersSidebarContainer = ({
  filters,
  facetsThatArentLoaded,
  searchFacets,
  ...otherProps
}: Props) => {
  const facets = filters.type
    ? sideFacetsForType(searchFacets, filters.type)
    : [];
  const facetsToRender = facets.filter(facet => {
    if (!facet.lazy) return true;
    return !facetsThatArentLoaded.includes(facet.name);
  });
  const searchableFacets = filters.type
    ? searchableFacetsForType(filters.type)
    : [];

  return (
    <SearchFiltersSidebar
      filters={filters}
      facetsToRender={facetsToRender}
      searchableFacets={searchableFacets}
      searchLocationActive={!isLocationEmpty(otherProps.searchLocation)}
      {...otherProps}
    />
  );
};

export default connect<Props, {||}, _, _, _, _>(
  mapStateToProps,
  mapDispatchToProps
)(SearchFiltersSidebarContainer);
